import { render, staticRenderFns } from "./WpMenuLeft.vue?vue&type=template&id=00ea937f&scoped=true&"
import script from "./WpMenuLeft.vue?vue&type=script&lang=js&"
export * from "./WpMenuLeft.vue?vue&type=script&lang=js&"
import style0 from "./WpMenuLeft.vue?vue&type=style&index=0&id=00ea937f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ea937f",
  null
  
)

export default component.exports